// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorComponent_container__3bmC1","btn":"ErrorComponent_btn__3b90u","textError":"ErrorComponent_textError__ZcFSv"};